// API configuration

// Determine the base URL based on the environment
const getBaseUrl = () => {
  // Check if we're in development mode (using npm start)
  if (process.env.NODE_ENV === 'development') {
    // In development, use the backend URL directly instead of relying on proxy
    return 'http://localhost:8000';
  }
  
  // In the browser in production, use the current domain (empty string for relative URLs)
  if (typeof window !== 'undefined') {
    return '';
  }
  
  // During build time, use the environment variable if available
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Fallback to localhost for development
  return 'http://localhost:8000';
};

export const API_BASE_URL = getBaseUrl();
